const state = {
  availableAgents: [],
  listAgentsQueue: [],
  history: {},
  paramsHistory: {},
};
export default state;
